import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

/** A hairline between the parts of a panel. */
export const Divider = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        height: 1,
        backgroundColor: aiColors.border,
        marginTop: rpx(16),
        marginBottom: rpx(2),
      }}
    />
  );
});
